export enum ScreenSize {
  XS,
  SM,
  MD,
  LG,
  XL
}
